// Working Cart Validation for Handwritten Cards
(function() {
  'use strict';
  
  console.log('🚨 Cart validation loaded - WORKING VERSION');
  
  let isProcessingCheckout = false;
  
  // Function to check for handwritten card OR signed copy gift set - BALANCED APPROACH
  function hasHandwrittenCard() {
    console.log('🔍 Checking for handwritten card or signed copy gift set...');
    
    // Step 1: Check for the checkbox first
    const checkbox = document.querySelector('input[name="giftCard"]#GiftWrapProduct');
    if (checkbox) {
      console.log('🔍 Checkbox found, checked:', checkbox.checked);
      return checkbox.checked;
    }
    
    // Step 2: If no checkbox, check if handwritten card OR signed copy gift set is actually in cart
    console.log('🔍 No checkbox found, checking cart content...');
    
    // Look for handwritten card OR signed copy gift set in the current page content
    const pageContent = document.documentElement.textContent.toLowerCase();
    const hasHandwrittenText = pageContent.includes('handwritten style card');
    const hasSignedCopyText = pageContent.includes('signed copy gift set');
    
    console.log('🔍 Page contains handwritten text:', hasHandwrittenText);
    console.log('🔍 Page contains signed copy gift set:', hasSignedCopyText);
    
    if (!hasHandwrittenText && !hasSignedCopyText) {
      console.log('❌ No handwritten card or signed copy gift set found anywhere');
      return false;
    }
    
    // If either text exists, check if we're in a cart context
    // Look for cart-specific indicators
    const cartIndicators = [
      document.querySelector('.yv_cart_drawer_wrapper'),
      document.querySelector('.cart-drawer'),
      document.querySelector('.mini-cart'),
      document.querySelector('[class*="cart"]'),
      window.location.pathname.includes('cart'),
      document.querySelector('.button-cart-box') // checkout button exists
    ];
    
    const inCartContext = cartIndicators.some(indicator => {
      if (typeof indicator === 'boolean') return indicator;
      return indicator && indicator.offsetParent !== null;
    });
    
    console.log('🔍 In cart context:', inCartContext);
    
    if (inCartContext && (hasHandwrittenText || hasSignedCopyText)) {
      // Final check: make sure it's not just random mention
      // Look for price indicators or quantity indicators near the text
      const elements = document.querySelectorAll('*');
      for (let element of elements) {
        const text = element.textContent.toLowerCase();
        if (text.includes('handwritten style card') || text.includes('signed copy gift set')) {
          // Check if this element or nearby elements have cart-like content
          const nearbyText = element.parentElement ? element.parentElement.textContent.toLowerCase() : '';
          const hasPrice = nearbyText.includes('$') || nearbyText.includes('price');
          const hasQuantity = nearbyText.includes('quantity') || nearbyText.includes('qty');
          const hasCartAction = nearbyText.includes('remove') || nearbyText.includes('delete') || nearbyText.includes('checkout');
          
          if (hasPrice || hasQuantity || hasCartAction) {
            console.log('✅ FOUND: Handwritten card or signed copy gift set with cart indicators');
            return true;
          }
        }
      }
    }
    
    console.log('❌ No handwritten card or signed copy gift set in cart context');
    return false;
  }
  
  // Function to check for note
  function hasNote() {
    const noteFields = document.querySelectorAll('textarea[name="note"], input[name="note"]');
    for (let field of noteFields) {
      if (field.value && field.value.trim().length > 0) {
        console.log('✅ Found note:', field.value.trim());
        return true;
      }
    }
    return false;
  }
  
  // Function to show popup
  function showPopup() {
    if (document.querySelector('.handwritten-card-popup')) return;
    
    const popup = document.createElement('div');
    popup.className = 'handwritten-card-popup';
    popup.innerHTML = `
      <div style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.6); z-index: 10000; display: flex; align-items: center; justify-content: center; padding: 20px;">
        <div style="background: white; max-width: 500px; width: 100%; padding: 30px; box-shadow: 0 4px 20px rgba(0,0,0,0.15); position: relative;">
          <button id="close-popup-btn" style="position: absolute; top: 15px; right: 15px; background: none; border: none; font-size: 24px; color: #999; cursor: pointer; width: 32px; height: 32px; display: flex; align-items: center; justify-content: center; border-radius: 50%; transition: all 0.2s ease; padding: 0; line-height: 1;" title="Close">×</button>
          <h3 style="margin: 0 0 20px; font-size: 18px; text-transform: uppercase; letter-spacing: 0.5px;">Personalized Message Required</h3>
          <p style="margin: 0 0 20px; color: #666; line-height: 1.6;">Please add a personal message for your item before proceeding to checkout.</p>
          <div style="background: #f8f8f8; padding: 12px 16px; margin: 0 0 20px; border-left: 2px solid #ccc; font-style: italic; font-size: 13px; color: #888;">
            This message will be beautifully handwritten
          </div>
          <div style="margin-bottom: 20px;">
            <label style="display: block; margin-bottom: 8px; font-size: 14px; text-transform: uppercase; letter-spacing: 0.5px;">Your Message:</label>
            <textarea id="popup-message" placeholder="Enter your handwritten card message here..." style="width: 100%; padding: 12px; border: 1px solid #ddd; min-height: 80px; font-family: inherit; box-sizing: border-box;" maxlength="200"></textarea>
            <div style="text-align: right; font-size: 12px; color: #999; margin-top: 4px;">
              <span id="char-count">0</span>/200 characters
            </div>
          </div>
          <div style="display: flex; gap: 12px; justify-content: flex-end;">
            <button id="remove-card-btn" style="padding: 12px 20px; border: 1px solid #ddd; background: white; color: #666; cursor: pointer; text-transform: uppercase; letter-spacing: 0.5px;">Remove Card</button>
            <button id="add-message-btn" style="padding: 12px 20px; border: 1px solid #333; background: #333; color: white; cursor: pointer; text-transform: uppercase; letter-spacing: 0.5px;" disabled>Add Message & Continue</button>
          </div>
        </div>
      </div>
    `;
    
    document.body.appendChild(popup);
    
    const messageInput = popup.querySelector('#popup-message');
    const charCount = popup.querySelector('#char-count');
    const addBtn = popup.querySelector('#add-message-btn');
    const removeBtn = popup.querySelector('#remove-card-btn');
    const closeBtn = popup.querySelector('#close-popup-btn');
    
    // Close button functionality
    closeBtn.addEventListener('click', function() {
      console.log('❌ Close button clicked - dismissing popup');
      popup.remove();
    });
    
    // Close button hover effect
    closeBtn.addEventListener('mouseenter', function() {
      this.style.background = '#f0f0f0';
      this.style.color = '#333';
    });
    
    closeBtn.addEventListener('mouseleave', function() {
      this.style.background = 'none';
      this.style.color = '#999';
    });
    
    // Close popup when clicking outside
    popup.addEventListener('click', function(e) {
      if (e.target === popup) {
        console.log('❌ Clicked outside popup - dismissing');
        popup.remove();
      }
    });
    
    // Close popup with Escape key
    document.addEventListener('keydown', function escapeHandler(e) {
      if (e.key === 'Escape') {
        console.log('❌ Escape key pressed - dismissing popup');
        popup.remove();
        document.removeEventListener('keydown', escapeHandler);
      }
    });
    
    // Character counter
    messageInput.addEventListener('input', function() {
      const count = this.value.length;
      charCount.textContent = count;
      addBtn.disabled = count === 0;
      addBtn.style.opacity = count === 0 ? '0.5' : '1';
    });
    
    // Remove card button
    removeBtn.addEventListener('click', function() {
      console.log('🗑️ Remove card button clicked');
      
      // Method 1: Uncheck the checkbox if it exists
      const checkbox = document.querySelector('input[name="giftCard"]#GiftWrapProduct');
      if (checkbox && checkbox.checked) {
        console.log('✅ Unchecking handwritten card checkbox');
        checkbox.click();
        popup.remove();
        return;
      }
      
      // Method 2: Find and click remove button for handwritten card line item
      const cartItems = document.querySelectorAll('.cart-item, .yv_cart_drawer_product_item, .line-item, [class*="product"]');
      console.log('🔍 Checking', cartItems.length, 'cart items for handwritten card');
      
      for (let item of cartItems) {
        const itemText = item.textContent.toLowerCase();
        if (itemText.includes('handwritten style card')) {
          console.log('🎯 Found handwritten card item:', item);
          
          // Look for remove/delete button in this item
          const removeSelectors = [
            '.remove', '.delete', '[data-remove]', '.cart-remove',
            '[class*="remove"]', '[class*="delete"]', 'button[title*="remove"]',
            'a[href*="remove"]', 'button[onclick*="remove"]', '.btn-remove'
          ];
          
          for (let selector of removeSelectors) {
            const removeBtn = item.querySelector(selector);
            if (removeBtn) {
              console.log('✅ Found remove button, clicking:', removeBtn);
              removeBtn.click();
              popup.remove();
              return;
            }
          }
          
          // If no remove button found, try parent elements
          const parentItem = item.closest('.cart-item, .yv_cart_drawer_product_item, .line-item');
          if (parentItem) {
            for (let selector of removeSelectors) {
              const removeBtn = parentItem.querySelector(selector);
              if (removeBtn) {
                console.log('✅ Found remove button in parent, clicking:', removeBtn);
                removeBtn.click();
                popup.remove();
                return;
              }
            }
          }
        }
      }
      
      // Method 3: Try to find remove button by looking for handwritten card in more specific cart containers
      const cartContainers = document.querySelectorAll('.yv_cart_drawer_wrapper, .cart-drawer, .mini-cart');
      for (let container of cartContainers) {
        const handwrittenElements = container.querySelectorAll('*');
        for (let element of handwrittenElements) {
          if (element.textContent.toLowerCase().includes('handwritten style card')) {
            // Look for remove button near this element
            const nearbyRemove = element.parentElement?.querySelector('[class*="remove"], [class*="delete"]');
            if (nearbyRemove) {
              console.log('✅ Found nearby remove button, clicking:', nearbyRemove);
              nearbyRemove.click();
              popup.remove();
              return;
            }
          }
        }
      }
      
      // Method 4: Try AJAX removal if we can identify the variant
      const handwrittenVariantId = findHandwrittenVariantId();
      if (handwrittenVariantId) {
        console.log('🔄 Attempting AJAX removal of variant:', handwrittenVariantId);
        removeViaAjax(handwrittenVariantId);
        popup.remove();
        return;
      }
      
      // Method 5: Fallback - alert user to remove manually
      console.log('❌ Could not find remove button, asking user to remove manually');
      alert('Please remove the handwritten card manually from your cart.');
      popup.remove();
    });
    
    // Helper function to find handwritten card variant ID
    function findHandwrittenVariantId() {
      try {
        // Look for data attributes or variant IDs associated with handwritten card
        const cartItems = document.querySelectorAll('[data-variant-id], [data-line-item-key]');
        for (let item of cartItems) {
          if (item.textContent.toLowerCase().includes('handwritten style card')) {
            return item.dataset.variantId || item.dataset.lineItemKey;
          }
        }
        
        // Check for JSON cart data
        const cartScripts = document.querySelectorAll('script[type="application/json"]');
        for (let script of cartScripts) {
          try {
            const data = JSON.parse(script.textContent);
            if (data.items) {
              for (let item of data.items) {
                if (item.product_title && item.product_title.toLowerCase().includes('handwritten')) {
                  return item.variant_id || item.key;
                }
              }
            }
          } catch (e) {
            // Continue to next script
          }
        }
      } catch (e) {
        console.log('Error finding variant ID:', e);
      }
      return null;
    }
    
    // Helper function to remove via AJAX
    function removeViaAjax(variantId) {
      if (window.fetch) {
        const formData = new FormData();
        formData.append('updates[' + variantId + ']', '0');
        
        fetch('/cart/update.js', {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          console.log('✅ Handwritten card removed via AJAX');
          // Refresh cart display
          if (window.location.reload) {
            setTimeout(() => window.location.reload(), 500);
          }
        })
        .catch(e => {
          console.log('❌ AJAX removal failed:', e);
          alert('Please remove the handwritten card manually from your cart.');
        });
      }
    }
    
    // Add message button
    addBtn.addEventListener('click', function() {
      const message = messageInput.value.trim();
      if (message) {
        console.log('📝 Adding message to cart notes:', message);
        
        // Find and update cart notes fields
        const noteSelectors = [
          'textarea[name="note"]',
          'input[name="note"]', 
          '#cart-note',
          '.cart-note textarea',
          '.cartNoteContainer textarea'
        ];
        
        let noteUpdated = false;
        
        noteSelectors.forEach(selector => {
          const fields = document.querySelectorAll(selector);
          fields.forEach(field => {
            if (field) {
              const prefix = 'Personalized Message: ';
              const existingNote = field.value.trim();
              let newNote = prefix + message;
              
              if (existingNote && !existingNote.includes(prefix)) {
                newNote = existingNote + '\n\n' + newNote;
              }
              
              field.value = newNote;
              field.dispatchEvent(new Event('input', { bubbles: true }));
              field.dispatchEvent(new Event('change', { bubbles: true }));
              
              console.log('✅ Updated note field:', selector);
              noteUpdated = true;
            }
          });
        });
        
        // Update cart via AJAX
        if (window.fetch) {
          const formData = new FormData();
          formData.append('note', 'Personalized Message: ' + message);
          
          fetch('/cart/update.js', {
            method: 'POST',
            body: formData
          }).then(response => response.json())
            .then(data => console.log('✅ Cart updated via AJAX'))
            .catch(e => console.log('ℹ️ AJAX update failed'));
        }
        
        popup.remove();
        
        console.log('✅ Proceeding to checkout...');
        isProcessingCheckout = true;
        
        setTimeout(() => {
          const checkoutBtn = document.querySelector('.button-cart-box') || 
                             document.querySelector('[class*="checkout"]');
          if (checkoutBtn) {
            checkoutBtn.click();
          } else {
            window.location.href = '/checkout';
          }
        }, 1000);
      }
    });
    
    messageInput.focus();
  }
  
  // Main validation function
  function validateCheckout(e) {
    console.log('🚨 Checkout attempt detected');
    
    if (isProcessingCheckout) {
      console.log('✅ Already processing, allowing checkout');
      isProcessingCheckout = false;
      return true;
    }
    
    if (hasHandwrittenCard() && !hasNote()) {
      console.log('❌ Handwritten card found but no note - blocking checkout');
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      showPopup();
      return false;
    }
    
    console.log('✅ Validation passed');
    return true;
  }
  
  // Initialize validation
  function init() {
    console.log('🔧 Initializing cart validation...');
    
    // Use CAPTURE PHASE to intercept clicks BEFORE other handlers
    document.addEventListener('click', function(e) {
      const target = e.target;
      
      // Get the actual link if clicking inside it (like on text or SVG)
      const link = target.closest('a');
      
      if (link && link.href && link.href.includes('/checkout')) {
        console.log('🚨 CHECKOUT LINK CLICKED:', link);
        if (!validateCheckout(e)) {
          return false;
        }
      }
    }, true); // TRUE = capture phase, runs FIRST
    
    console.log('✅ Cart validation initialized with CAPTURE phase');
  }
  
  // Initialize when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();